/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Samples_Reject_Dialog_DescriptionInputs */

const en_samples_reject_dialog_description = /** @type {(inputs: Samples_Reject_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Provide a reason for rejecting ${i?.count} sample(s).`)
};

const es_samples_reject_dialog_description = /** @type {(inputs: Samples_Reject_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Proporcione una razon para rechazar ${i?.count} muestra(s).`)
};

/**
* | output |
* | --- |
* | "Provide a reason for rejecting {count} sample(s)." |
*
* @param {Samples_Reject_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_reject_dialog_description = /** @type {((inputs: Samples_Reject_Dialog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Reject_Dialog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_reject_dialog_description(inputs)
	return es_samples_reject_dialog_description(inputs)
});